/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Description_LabelInputs */

const en_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue description`)
};

const fr_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description de l'incident`)
};

const de_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problembeschreibung`)
};

const it_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del problema`)
};

const ru_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание проблемы`)
};

const es_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del problema`)
};

const zh_cn2_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题描述`)
};

const ja_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題の説明`)
};

const hi_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुद्दे का विवरण`)
};

const pt_pt2_manual_qc_description_label = /** @type {(inputs: Manual_Qc_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição do problema`)
};

/**
* | output |
* | --- |
* | "Issue description" |
*
* @param {Manual_Qc_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_description_label = /** @type {((inputs?: Manual_Qc_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_description_label(inputs)
	if (locale === "de") return de_manual_qc_description_label(inputs)
	if (locale === "it") return it_manual_qc_description_label(inputs)
	if (locale === "ru") return ru_manual_qc_description_label(inputs)
	if (locale === "es") return es_manual_qc_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_description_label(inputs)
	if (locale === "ja") return ja_manual_qc_description_label(inputs)
	if (locale === "hi") return hi_manual_qc_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_description_label(inputs)
	return en_manual_qc_description_label(inputs)
});